import { ArrowRight } from 'lucide-react'
import type { AnchorHTMLAttributes, ReactNode } from 'react'

type ArrowLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: ReactNode
  variant?: 'text' | 'button'
}

export function ArrowLink({
  children,
  className = '',
  variant = 'text',
  ...props
}: ArrowLinkProps) {
  return (
    <a className={`arrow-link arrow-link--${variant} ${className}`.trim()} {...props}>
      <span>{children}</span>
      <ArrowRight aria-hidden="true" size={18} strokeWidth={1.5} />
    </a>
  )
}
